var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('datalist',{attrs:{"id":_vm.elementId}},_vm._l((_vm.options),function(option,index){return _c('option',{key:index,domProps:{"value":option}},[_vm._v(_vm._s(option))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }